var _path, _path2, _path3, _path4;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconThongbao02 = function SvgIconThongbao02(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1539 7.9248C23.7801 8.41973 24.9998 9.90452 24.9998 11.7193C24.9998 13.534 23.7801 15.0188 22.1539 15.5137",
    stroke: "#2F8BFF",
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.64087 8.28809V15.1256",
    stroke: "#05060B",
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4607 1H20.6861C21.4374 1 22.1137 1.67624 22.1137 2.42762V20.9115C22.1137 21.6629 21.4374 22.3391 20.6861 22.3391H20.4607C19.6341 22.3391 14.7502 15.0507 9.49056 15.0507H2.95358C1.90165 15.0507 1 14.1491 1 13.0972V10.0917C1 9.03973 1.90165 8.13808 2.95358 8.13808H9.49056C14.7502 8.28836 19.6341 1 20.4607 1Z",
    stroke: "#05060B",
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.06306 15.126C8.36361 16.6287 7.91279 18.2066 8.88958 19.6342L10.4675 22.1138C10.8432 22.7149 10.2421 23.7668 9.49068 23.7668H7.08627C6.41003 23.7668 5.65866 23.1657 5.43324 22.4895L3.70508 15.126H8.06306Z",
    stroke: "#05060B",
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconThongbao02, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-thongbao-02.a897a520.svg";
export { ForwardRef as ReactComponent };